import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { RolePermissionService, SkylarkPermission } from 'app/_services/role-permission.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'contractors-list',
  templateUrl: './contractors-list.component.html'
})
export class ContractorsListComponent implements OnInit {
  public contractors: any[];
  private routeRole: any;

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  public defaultSortField = 'name';
  public defaultSortOrder = 1;
  private sortOrderToText = (sortOrder: number) => { return sortOrder === 1 ? 'asc' : 'desc'; }
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  public isFilterLoading: boolean;
  public filterText: string = '';
  public isReadOnly: boolean;

  private siteOwnerSkylarkUserId: any

  constructor(
    private contractorService: ContractorService,
    private notificationService: NotificationService,
    private router: Router,
    private globals: Globals,
    private fb: FormBuilder,
    private rolePermissionService: RolePermissionService,
  ) {
    this.routeRole = globals.user.routeRole;

    this.isReadOnly = !this.rolePermissionService.hasPermission(SkylarkPermission.WRITE__CONTRACTORS);

    this.siteOwnerSkylarkUserId = this.globals.siteOwnerUsers[0].skylarkUserId;
  }

  ngOnInit() {
    this.resetPagination();
  }

  private getAllContractors() {
    this.contractorService.getLinkedContractors(this.siteOwnerSkylarkUserId, this.pagination, this.selectedSort, this.filterText).subscribe((data: any) => {
      this.contractors = data.body;
      this.contractors.forEach(contractor => {
        contractor.manager = contractor.maintenanceManager ? contractor.maintenanceManager.firstName + ' ' + contractor.maintenanceManager.lastName : null;
      });

      this.pagination.totalRecords = data.totalRecords;
      this.isFilterLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving worker list');
      this.isFilterLoading = false;
    });
  }

  public onFilterTextChanged(filterText: string) {
    this.isFilterLoading = true;
    this.filterText = filterText;

    this.goToFirstPage();
    this.getAllContractors();
  }

  public onRowSelect(event) {
    this.router.navigate(['/' + this.routeRole + '/contractors', event.data.id, 'details']);
  }

  public goToContractorInvite() {
    this.router.navigate(['/' + this.routeRole + '/contractors', 'invite']);
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllContractors();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();

    this.getAllContractors();
  }

  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

    this.goToFirstPage();

    this.getAllContractors();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
